import { useState } from "react";
import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { TopBar } from "./TopBar";
import { NAV_DESKTOP_UP } from "./constants";
import { LegalFooter } from "./LegalFooter";

export function AppLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        width: "100%",
        maxWidth: "100vw",
        overflowX: "hidden",
      }}
    >
      <TopBar onMenuClick={() => setMobileOpen(true)} />
      <Sidebar
        mobileOpen={mobileOpen}
        onMobileClose={() => setMobileOpen(false)}
      />
      <Box
        component="main"
        sx={{
          flex: "1 1 auto",
          minWidth: 0,
          minHeight: "100vh",
          bgcolor: "background.default",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            display: { xs: "block", [NAV_DESKTOP_UP]: "none" },
            flexShrink: 0,
            height: "calc(56px + env(safe-area-inset-top, 0px))",
          }}
          aria-hidden
        />
        <Box
          sx={{
            flex: "1 1 auto",
            width: "100%",
            pb: {
              xs: "max(12px, env(safe-area-inset-bottom, 0px))",
              [NAV_DESKTOP_UP]: 0,
            },
          }}
        >
          <Outlet />
        </Box>
        <LegalFooter />
      </Box>
    </Box>
  );
}
